angular.module('st')
    .controller('lrTopNavCtrl', [
        '$rootScope',
        function ($rootScope) {
            var ctrl = this;

            ctrl.expanderClasses = {
                open: true
            };

            $rootScope.$on('topNavToggle', function () {
                if (ctrl.expanderClasses.open) $rootScope.$broadcast('topNavClose');
                else $rootScope.$broadcast('topNavOpen');
            });

            $rootScope.$on('topNavClose', function () {
                ctrl.expanderClasses.open = false;
            });

            $rootScope.$on('topNavOpen', function () {
                ctrl.expanderClasses.open = true;
            });
        }]);